var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account_box" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("礼金补贴活动商品管理")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: {
            background: "#fff",
            padding: "20px",
            "border-radius": "8px",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-start",
                "flex-wrap": "wrap",
              },
            },
            [
              _c("div", [
                _c("div", [_vm._v("淘礼金账户余额")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#222",
                      "font-weight": "bold",
                      "font-size": "18px",
                      "margin-top": "10px",
                    },
                  },
                  [
                    _vm._v(_vm._s(_vm.balanceAmt || 0)),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "normal",
                          "font-size": "15px",
                          "margin-left": "3px",
                        },
                      },
                      [_vm._v("元")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { margin: "0 100px" } }, [
                _c("div", [_vm._v("累计发放礼金红包数")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#222",
                      "font-weight": "bold",
                      "font-size": "18px",
                      "margin-top": "10px",
                    },
                  },
                  [
                    _vm._v(_vm._s(_vm.giftSendCount || 0)),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "normal",
                          "font-size": "15px",
                          "margin-left": "3px",
                        },
                      },
                      [_vm._v("个")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", [_vm._v("累计发放礼金红包金额")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#222",
                      "font-weight": "bold",
                      "font-size": "18px",
                      "margin-top": "10px",
                    },
                  },
                  [
                    _vm._v(_vm._s(_vm.giftSendAmt || 0)),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "normal",
                          "font-size": "15px",
                          "margin-left": "3px",
                        },
                      },
                      [_vm._v("元")]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: {
            background: "#fff",
            padding: "20px",
            "border-radius": "8px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "search_criteria" },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "0" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入活动名称查询", clearable: "" },
                    model: {
                      value: _vm.queryData.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryData, "title", $$v)
                      },
                      expression: "queryData.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: "选择搜索所属活动",
                  },
                  model: {
                    value: _vm.queryData.activityIdList,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "activityIdList", $$v)
                    },
                    expression: "queryData.activityIdList",
                  },
                },
                _vm._l(_vm.activityOption, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.activityName, value: item.id },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择上下架状态", clearable: "" },
                      model: {
                        value: _vm.queryData.goodsStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryData, "goodsStatus", $$v)
                        },
                        expression: "queryData.goodsStatus",
                      },
                    },
                    [
                      _c("el-option", { attrs: { value: 0, label: "下架" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { value: 1, label: "上架" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex",
                  staticStyle: { width: "fit-content", height: "40px" },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { height: "40px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.onInquire },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "ml10",
                      staticStyle: { height: "40px" },
                      attrs: { type: "info", plain: "" },
                      on: { click: _vm.onInitialize },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.onAdd },
                    },
                    [_vm._v("新增+")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: {
            background: "#fff",
            padding: "20px",
            "border-radius": "8px",
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": { "text-align": "center" },
                "cell-style": { "text-align": "center" },
                data: _vm.tableData,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "所属活动", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.activityName))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品信息", width: "530" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "flex-start",
                              "font-size": "12px",
                            },
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                display: "block",
                                width: "80px",
                                height: "80px",
                              },
                              attrs: { src: scope.row.goodsPic },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "5px" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ellipsis-multiline",
                                    staticStyle: { "text-align": "left" },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "20px",
                                        height: "20px",
                                        "vertical-align": "middle",
                                      },
                                      attrs: {
                                        alt: "",
                                        src: _vm.picObj[scope.row.platformCode],
                                      },
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.title) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      "text-align": "left",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                商品ID:" +
                                        _vm._s(scope.row.goodsId) +
                                        "\n                "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          background: "#F4F4F5",
                                          color: "#797979",
                                          border: "1px solid #909399",
                                          padding: "1px 3px",
                                          "margin-left": "3px",
                                          cursor: "pointer",
                                          "border-radius": "5px",
                                          "font-size": "9px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copy(scope.row.goodsId)
                                          },
                                        },
                                      },
                                      [_vm._v("复制")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start",
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _vm._v("\n                  券后价："),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "￥" + _vm._s(scope.row.couponPrice)
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-left": "40px" },
                                      },
                                      [
                                        _vm._v("\n                  原价："),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "text-decoration": "line-through",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(scope.row.originPrice)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "实际券后价", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.actualCouponPrice)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "活动内排序", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.sortNo))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "礼金金额", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(scope.row.giftAmt)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "累计上架", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("div", [_vm._v(_vm._s(scope.row.stockTotal))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "剩余库存", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.stockRemain))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "被领取数", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.claimCount))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "实际核销", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.verifyCount))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "上下架状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-color": "#13ce66",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.allChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.goodsStatus,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "goodsStatus", $$v)
                            },
                            expression: "scope.row.goodsStatus",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "下架原因", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.offReason))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.changeStock(scope.row)
                              },
                            },
                          },
                          [_vm._v("库存调整")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.detail(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.del(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "20px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.queryData.page.size,
                  layout: "total, prev, pager, next, sizes,jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "" +
              (_vm.eventsType === "add"
                ? "商品添加"
                : _vm.eventsType === "upDate"
                ? "商品编辑"
                : "库存调整"),
            visible: _vm.dialogVisible,
            width: "65%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _vm.dialogVisible
            ? _c(
                "div",
                { staticClass: "fc" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      staticStyle: { width: "90%" },
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "170px",
                      },
                    },
                    [
                      _vm.eventsType !== "stock"
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "渠道：",
                                    prop: "platformCode",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: {
                                        disabled: _vm.eventsType === "upDate",
                                      },
                                      model: {
                                        value: _vm.ruleForm.platformCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "platformCode",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.platformCode",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "TB" } },
                                        [_vm._v("淘宝")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "所属活动：",
                                    prop: "activityId",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: _vm.eventsType === "upDate",
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.ruleForm.activityId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "activityId",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.activityId",
                                      },
                                    },
                                    _vm._l(_vm.activityOption, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.activityName,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商品口令/链接：",
                                    prop: "goodsCommand",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: _vm.eventsType === "upDate",
                                          placeholder: "请输入",
                                        },
                                        model: {
                                          value: _vm.ruleForm.goodsCommand,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "goodsCommand",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.goodsCommand",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.eventsType !== "upDate"
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "10px",
                                              },
                                              attrs: { plain: "" },
                                              on: { click: _vm.findGoods },
                                            },
                                            [_vm._v("搜索")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "商品ID：", prop: "goodsId" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: true,
                                          placeholder: "请输入",
                                        },
                                        model: {
                                          value: _vm.ruleForm.goodsId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "goodsId",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.goodsId",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copy(
                                                _vm.ruleForm.goodsId
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("复制")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商品主图：",
                                    prop: "goodsPic",
                                  },
                                },
                                [
                                  _vm.ruleForm.goodsPic
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "130px",
                                          height: "130px",
                                        },
                                        attrs: {
                                          "preview-src-list": [
                                            _vm.ruleForm.goodsPic,
                                          ],
                                          src: _vm.ruleForm.goodsPic,
                                          fit: "scale-down",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "商品标题：", prop: "title" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: true,
                                      placeholder: "请输入",
                                    },
                                    model: {
                                      value: _vm.ruleForm.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "title", $$v)
                                      },
                                      expression: "ruleForm.title",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "原价：",
                                    prop: "originPrice",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: true,
                                      placeholder: "请输入",
                                    },
                                    model: {
                                      value: _vm.ruleForm.originPrice,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "originPrice",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.originPrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "券后价：",
                                    prop: "couponPrice",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: true,
                                      placeholder: "请输入",
                                    },
                                    model: {
                                      value: _vm.ruleForm.couponPrice,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "couponPrice",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.couponPrice",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#F59A23",
                                        "font-size": "12px",
                                      },
                                    },
                                    [_vm._v("此处展示商品最新的券后价信息")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "实际券后价:",
                                    prop: "actualCouponPrice",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.ruleForm.actualCouponPrice,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "actualCouponPrice",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.actualCouponPrice",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#F59A23",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "若商品券后价与实际价格不一致，可在此处编辑实际的券后价进行上架，补贴金额将按照该价格进行比较"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "上架数量：",
                                    prop: "stockTotal",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入内容",
                                      disabled: _vm.eventsType === "upDate",
                                    },
                                    model: {
                                      value: _vm.ruleForm.stockTotal,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "stockTotal",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "ruleForm.stockTotal",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#F59A23",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "首次设置后将不可编辑, 后续如需追加库存, 请在商品列表点击「补充库存」操作, 追加后总上架数量将同步更新"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "礼金红包金额：",
                                    prop: "giftAmt",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入内容" },
                                    model: {
                                      value: _vm.ruleForm.giftAmt,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "giftAmt", $$v)
                                      },
                                      expression: "ruleForm.giftAmt",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#F59A23",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "设定礼金红包金额时，务必参考价格最低的 SKU 款式价格，红包金额不得大于商品券后价。"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "排序：", prop: "sortNo" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入内容" },
                                    model: {
                                      value: _vm.ruleForm.sortNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "sortNo",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "ruleForm.sortNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商品状态：",
                                    prop: "goodsStatus",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.ruleForm.goodsStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "goodsStatus",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.goodsStatus",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("上架"),
                                      ]),
                                      _vm._v(" "),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("下架"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "调整方式：",
                                    prop: "stockAdjustType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.ruleForm.stockAdjustType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "stockAdjustType",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.stockAdjustType",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("补充"),
                                      ]),
                                      _vm._v(" "),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("减少"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "库存调整数量：",
                                    prop: "stockAdjustQty",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入内容" },
                                    model: {
                                      value: _vm.ruleForm.stockAdjustQty,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "stockAdjustQty",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "ruleForm.stockAdjustQty",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#F59A23",
                                        "font-size": "12px",
                                      },
                                    },
                                    [_vm._v("库存调整后系统自动计算并展示")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "商品标题：" } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.title) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "累计投放：" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "padding-top": "1px" } },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.stockTotal) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "剩余库存：" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "padding-top": "1px" } },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.stockRemain) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("确认")]
                          ),
                          _vm._v(" "),
                          _vm.eventsType === "upDate"
                            ? _c(
                                "el-button",
                                { on: { click: _vm.handleClose } },
                                [_vm._v("关闭")]
                              )
                            : _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.resetForm("ruleForm")
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }